import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
interface AccordionItemProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}
export function AccordionItem({
  title,
  defaultOpen = false,
  children
}: AccordionItemProps) {
  const [open, setOpen] = useState(defaultOpen);
  return <div className="border-b border-line" data-id="element-16" data-mp="2n3z0dbyj4znm">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="flex w-full items-center justify-between py-5 text-left text-[15px] font-medium text-ink" data-id="element-17" data-mp="2n2w74xdqil4j">
        {title}
        <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${open ? "rotate-45" : ""}`} data-id="element-18" data-mp="2w3cc6ba4m0bi" />
      </button>
      <AnimatePresence initial={false} data-id="element-19" data-mp="2s3ttlm5s21bu">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-20" data-mp="11rntpz4orfmd">
            <div className="pb-6 text-[15px] leading-relaxed text-ink/75" data-id="element-21" data-mp="3l2f8h6r1f5f8">{children}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}